// src/config.js
export const ITEMS = [
    // REALISTE
    "Travailler avec son corps",
    "Utiliser des outils pour fabriquer, réparer, entretenir",
    "Améliorer un dispositif, des machines, des appareils",
    "Travailler avec son habileté manuelle",
    
    // INVESTIGATEUR
    "Réfléchir à des problèmes, à des situations complexes",
    "Rechercher et recueillir de l'information",
    "Résoudre des problèmes avec des nombres",
    "Manier les mots, rédiger",
    
    // SOCIAL
    "Accompagner, aider autrui",
    "Travailler en équipe",
    "Communiquer, informer, échanger avec des personnes",
    "Parler devant un grand nombre de personnes",
    
    // ENTREPRENEUR
    "Exercer son leadership",
    "Entreprendre et réaliser un projet",
    "Présentez avec conviction une idée, un produit ou un projet",
    "Travailler avec une grande autonomie et peu de routine",
    
    // ARTISTIQUE
    "Transformer, adapter",
    "Exprimer son sens artistique",
    "Créer, Inventer, Innover",
    "Exprimer sa sensibilité",
    
    // CONVENTIONNEL
    "Travailler avec les technologies",
    "Assumer des tâches administratives",
    "Suivre des règles, des consignes",
    "Superviser l'exécution des tâches"
];

